import { defineMessages } from 'react-intl'

export default defineMessages({
  netAmount: {
    id: 'containers.HandoverPage.netAmount',
    defaultMessage: 'Net Amount',
  },
  company: {
    id: 'containers.HandoverPage.company',
    defaultMessage: 'Company',
  },
  priority: {
    id: 'containers.HandoverPage.priority',
    defaultMessage: 'Priority',
  },
  classification: {
    id: 'containers.HandoverPage.classification',
    defaultMessage: 'Classification',
  },
  deadline: {
    id: 'containers.HandoverPage.deadline',
    defaultMessage: 'Deadline',
  },
  toBeDetermined: {
    id: 'containers.HandoverPage.toBeDetermined',
    defaultMessage: 'To be determined',
  },
  salesResponsible: {
    id: 'containers.HandoverPage.salesResponsible',
    defaultMessage: 'Sales Responsible',
  },
  products: {
    id: 'containers.HandoverPage.products',
    defaultMessage: 'Products',
  },
  services: {
    id: 'containers.HandoverPage.services',
    defaultMessage: 'Services',
  },
  notSpecified: {
    id: 'containers.HandoverPage.notSpecified',
    defaultMessage: 'Not specified',
  },
  expectedLanguages: {
    id: 'containers.HandoverPage.expectedLanguages',
    defaultMessage: 'Expected languages',
  },
  notSupplied: {
    id: 'containers.HandoverPage.notSupplied',
    defaultMessage: 'Not supplied',
  },
  voiceTalents: {
    id: 'containers.HandoverPage.voiceTalents',
    defaultMessage: 'Voice talents',
  },
  bookedVoiceTalents: {
    id: 'containers.HandoverPage.bookedVoiceTalents',
    defaultMessage: 'Booked voice talents',
  },
  preferredLanguages: {
    id: 'containers.HandoverPage.preferredLanguages',
    defaultMessage: 'Preferred languages',
  },
  deliveryPrimary: {
    id: 'containers.HandoverPage.deliveryPrimary',
    defaultMessage: 'Delivery - Primary',
  },
  deliverySecondary: {
    id: 'containers.HandoverPage.deliverySecondary',
    defaultMessage: 'Delivery - Secondary',
  },
  declinedBy: {
    id: 'containers.HandoverPage.declinedBy',
    defaultMessage: 'Declined by',
  },
  timedOutAt: {
    id: 'containers.HandoverPage.timedOutAt',
    defaultMessage: 'Timed out at',
  },
  sendToDispatcher: {
    id: 'containers.HandoverPage.sendToDispatcher',
    defaultMessage: 'Escalated to dispatcher by',
  },
  returnedToSalesBy: {
    id: 'containers.HandoverPage.returnedToSalesBy',
    defaultMessage: 'Declined and returned to sales by',
  },
  currentlyAt: {
    id: 'containers.HandoverPage.currentlyAt',
    defaultMessage: 'Currently at, and waiting for,',
  },
  dontHaveTime: {
    id: 'containers.HandoverPage.dontHaveTime',
    defaultMessage: 'I don\'t have time',
  },
  returnToSales: {
    id: 'containers.HandoverPage.returnToSales',
    defaultMessage: 'Return to sales',
  },
  escalateToDispatch: {
    id: 'containers.HandoverPage.escalateToDispatch',
    defaultMessage: 'Escalate to dispatcher',
  },
  handoverAccepted: {
    id: 'containers.HandoverPage.handoverAccepted',
    defaultMessage: 'Handover accepted..',
  },
  accept: {
    id: 'containers.HandoverPage.accept',
    defaultMessage: 'Accept',
  },
  decline: {
    id: 'containers.HandoverPage.decline',
    defaultMessage: 'Decline',
  },
  snooze: {
    id: 'containers.HandoverPage.snooze',
    defaultMessage: 'Snooze',
  },
  deferToBacklog: {
    id: 'containers.HandoverPage.deferToBacklog',
    defaultMessage: 'Defer handover to my backlog',
  },
  defer: {
    id: 'containers.HandoverPage.defer',
    defaultMessage: 'Defer',
  },
  release: {
    id: 'containers.HandoverPage.release',
    defaultMessage: 'Release',
  },
  released: {
    id: 'containers.HandoverPage.released',
    defaultMessage: 'Removed from backlog, and released for assignment',
  },
})
